module.exports = [{
      plugin: require('D:/www/xcite-homepage/node_modules/gatsby-plugin-typography/gatsby-browser'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    }]
